"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var antd_1 = require("antd");
var FontAwesome_1 = require("../../../../../../shared/components/icons/FontAwesome");
var CommonStatCard = /** @class */ (function (_super) {
    __extends(CommonStatCard, _super);
    function CommonStatCard(props) {
        var _this = _super.call(this, props) || this;
        _this._card_outer_style = {
            width: "200px",
            height: "250px",
            margin: 5,
            boxShadow: "0 2px 4px 0 rgba(0, 0, 0, 0.2), 0 3px 10px 0 rgba(0, 0, 0, 0.19)"
        };
        _this._card_inner_style = {
            height: "100%",
            width: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            flexDirection: "column"
        };
        _this._pWidth = 160;
        _this._txtWidth = "160px";
        return _this;
    }
    CommonStatCard.prototype.componentWillMount = function () {
        var _this = this;
        this.SID = this.props.data.Subscribe("*", function (id, data) {
            _this.setState({
                data: data.common_stat
            });
        });
        this.SID_STATE = this.props.state.Subscribe("*", function (id, data) {
            _this.setState({
                dtFrom: data.dtFrom,
                dtTo: data.dtTo,
                dtFormat: data.dtTimeFormat
            });
        });
        this.setState({
            data: this.props.data.DATA.common_stat,
            dtFrom: this.props.state.DATA.dtFrom,
            dtTo: this.props.state.DATA.dtTo,
            dtFormat: this.props.state.DATA.dtTimeFormat
        }, function () {
            _this.loadData();
        });
    };
    CommonStatCard.prototype.componentWillUnmount = function () {
        this.props.data.UnSubscribe(this.SID);
        this.props.state.UnSubscribe(this.SID_STATE);
    };
    CommonStatCard.prototype.loadData = function () {
        this.props.data.LoadCommonData({
            from_year: this.state.dtFrom.get('year'),
            from_month: this.state.dtFrom.get('month') + 1,
            from_day: this.state.dtFrom.get('date'),
            from_hour: this.state.dtFrom.get('hour'),
            from_minute: this.state.dtFrom.get('minute'),
            from_second: this.state.dtFrom.get('second'),
            to_year: this.state.dtTo.get('year'),
            to_month: this.state.dtTo.get('month') + 1,
            to_day: this.state.dtTo.get('date'),
            to_hour: this.state.dtTo.get('hour'),
            to_minute: this.state.dtTo.get('minute'),
            to_second: this.state.dtTo.get('second'),
        }, function () { });
    };
    CommonStatCard.prototype.drawRegisteredUsersCard = function () {
        var _this = this;
        return (React.createElement(antd_1.Card, { bordered: true, style: this._card_outer_style },
            React.createElement("div", { style: this._card_inner_style },
                React.createElement(antd_1.Progress, { width: this._pWidth, strokeWidth: 5, type: "dashboard", percent: 75, style: { margin: "5px" }, status: "active", format: function (percent) { return "" + _this.state.data.new_players_count; } }),
                React.createElement("div", { style: { textAlign: "center", width: this._txtWidth } },
                    React.createElement(FontAwesome_1.FA, { left: true, icon: "user-plus" }),
                    React.createElement("b", null, "\u041D\u043E\u0432\u044B\u0445 \u0438\u0433\u0440\u043E\u043A\u043E\u0432 \u0437\u0430\u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0438\u0440\u043E\u0432\u0430\u043D\u043E")))));
    };
    CommonStatCard.prototype.drawRegisteredNewPlayersCard = function () {
        var _this = this;
        return (React.createElement(antd_1.Card, { bordered: true, style: this._card_outer_style },
            React.createElement("div", { style: this._card_inner_style },
                React.createElement(antd_1.Progress, { width: this._pWidth, strokeWidth: 5, type: "dashboard", percent: 75, style: { margin: "5px" }, status: "active", format: function (percent) { return "" + _this.state.data.total_players_count; } }),
                React.createElement("div", { style: { textAlign: "center", width: this._txtWidth } },
                    React.createElement(FontAwesome_1.FA, { left: true, icon: "user-check" }),
                    React.createElement("b", null, "\u0412\u0441\u0435\u0433\u043E \u0438\u0433\u0440\u043E\u043A\u043E\u0432 \u0437\u0430\u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0438\u0440\u043E\u0432\u0430\u043D\u043E")))));
    };
    CommonStatCard.prototype.drawAllActivePlayersCard = function () {
        var _this = this;
        return (React.createElement(antd_1.Card, { bordered: true, style: this._card_outer_style },
            React.createElement("div", { style: this._card_inner_style },
                React.createElement(antd_1.Progress, { status: "success", width: this._pWidth, strokeWidth: 5, type: "dashboard", percent: 75, style: { margin: "5px" }, format: function (percent) { return "" + _this.state.data.total_players_online; } }),
                React.createElement("div", { style: { textAlign: "center", width: this._txtWidth } },
                    React.createElement(FontAwesome_1.FA, { left: true, icon: "users" }),
                    React.createElement("b", null, "\u0418\u0433\u0440\u043E\u043A\u043E\u0432 \u0441\u0435\u0439\u0447\u0430\u0441 \u043E\u043D\u043B\u0430\u0439\u043D")))));
    };
    CommonStatCard.prototype.drawPlayersDepositCard = function () {
        var _this = this;
        return (React.createElement(antd_1.Card, { bordered: true, style: this._card_outer_style },
            React.createElement("div", { style: this._card_inner_style },
                React.createElement(antd_1.Progress, { status: "success", width: this._pWidth, strokeWidth: 5, type: "dashboard", percent: 75, style: { margin: "5px" }, format: function (percent) { return "" + _this.state.data.total_deposited_amount.toFixed(2); } }),
                React.createElement("div", { style: { textAlign: "center", width: this._txtWidth } },
                    React.createElement(FontAwesome_1.FA, { left: true, icon: "wallet" }),
                    React.createElement("b", null,
                        "\u0421\u0443\u043C\u043C\u0430 \u0434\u0435\u043F\u043E\u0437\u0438\u0442\u043E\u0432 \u0438\u0433\u0440\u043E\u043A\u043E\u0432 ",
                        this.state.data.currency_symbol)))));
    };
    CommonStatCard.prototype.drawPlayersWithdrawCard = function () {
        var _this = this;
        return (React.createElement(antd_1.Card, { bordered: true, style: this._card_outer_style },
            React.createElement("div", { style: this._card_inner_style },
                React.createElement(antd_1.Progress, { status: "exception", width: this._pWidth, strokeWidth: 5, type: "dashboard", percent: 75, style: { margin: "5px" }, format: function (percent) { return "" + _this.state.data.total_withdraw_amount.toFixed(2); } }),
                React.createElement("div", { style: { textAlign: "center", width: this._txtWidth } },
                    React.createElement(FontAwesome_1.FA, { left: true, icon: "wallet" }),
                    React.createElement("b", null,
                        "\u0421\u0443\u043C\u043C\u0430 \u0441\u043D\u044F\u0442\u0438\u0439 \u0438\u0433\u0440\u043E\u043A\u043E\u0432 ",
                        this.state.data.currency_symbol)))));
    };
    CommonStatCard.prototype.drawSystemProfit = function () {
        var _this = this;
        return (React.createElement(antd_1.Card, { bordered: true, style: this._card_outer_style },
            React.createElement("div", { style: this._card_inner_style },
                React.createElement(antd_1.Progress, { status: "success", width: this._pWidth, strokeWidth: 5, type: "dashboard", percent: 75, style: { margin: "5px" }, format: function (percent) { return "" + _this.state.data.total_profit.toFixed(2); } }),
                React.createElement("div", { style: { textAlign: "center", width: this._txtWidth } },
                    React.createElement(FontAwesome_1.FA, { left: true, icon: "hand-holding-usd" }),
                    React.createElement("b", null,
                        "\u0412\u044B\u0440\u0443\u0447\u043A\u0430 \u043F\u043E \u0432\u0441\u0435\u043C \u0431\u0440\u0435\u043D\u0434\u0430\u043C ",
                        this.state.data.currency_symbol)))));
    };
    CommonStatCard.prototype.render = function () {
        return (React.createElement(antd_1.Card, { title: "Общая статистика", bordered: false, style: { width: "100%", height: "100%" } },
            React.createElement("div", { style: { height: "100%", width: "100%", display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "center", flexWrap: "wrap" } },
                this.drawRegisteredUsersCard(),
                this.drawRegisteredNewPlayersCard(),
                this.drawAllActivePlayersCard(),
                this.drawPlayersDepositCard(),
                this.drawPlayersWithdrawCard(),
                this.drawSystemProfit())));
    };
    return CommonStatCard;
}(React.Component));
exports.default = CommonStatCard;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/main_dashboard/ui/component/CommonStatCard.tsx
// module id = 1748
// module chunks = 0